import { FaberApi } from 'api'
import { AxiosPromise } from 'axios'
import {
  DeleteVoucherResponse,
  GetVouchers,
  GetVoucherStats,
  UploadVoucherResponse
} from 'types/api/faber/vouchers.type'

class VouchersAPI {
  /**
   * To get the list of vouchers
   * from tbl_vouchers
   */
  static getAllVouchers(
    faberToken: string,
    page: number,
    pageSize?: number
  ): AxiosPromise<GetVouchers> {
    const pgSize = pageSize ? `&page_size=${pageSize}` : ''
    return FaberApi.httpGet(
      `/vouchers?page=${page}${pgSize}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  /**
   * To get the list of vouchers
   * from tbl_voucher
   */
  static getAllVoucher(
    faberToken: string,
    userId: string
  ) {
    return FaberApi.httpGet(
      `/sim/ops/user/${userId}/voucher`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then(res => res.data)
  }

  /**
   * To get the list of vouchers for external users
   * from tbl_voucher
   */
  static getExternalAllVoucher(
    faberToken: string,
    userId: string
  ) {
    return FaberApi.httpGet(
      `/sim/ext/user/${userId}/voucher`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then(res => res.data)
  }

  /**
   * To get jetpass vouchers dashboard
   * this is for jetpass -> it queries tbl_voucher
   * not to be confused with the previous voucher calls
   */
  static getDashboardVouchers(faberToken: string) {
    return FaberApi.httpGet(
      `/sim/ops/voucher/overview`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    ).then(res => res.data)
  }

  /**
   * To upload jetpass vouchers
   * into the tbl_voucher table
   * need a body param so that useMutation can still work
   */
  static uploadVouchers(body:{
    faberToken: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    uploadObject: any // the form data
  }): AxiosPromise {
    return FaberApi.httpPost(
      `/sim/ops/voucher/upload-passes`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body.uploadObject
    )
  }

  /**
   * To get current voucher stats
   */
  static getVoucherStats(faberToken: string): AxiosPromise<GetVoucherStats> {
    return FaberApi.httpGet(
      '/vouchers/summary',
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  /**
   * For ops to mass upload new vouchers via CSV
   * @param uploadObject
   * @returns
   */
  static createVouchers(body: {
    uploadObject: { data: VouchersCSVData[] }
    faberToken: string
  }): AxiosPromise<UploadVoucherResponse> {
    return FaberApi.httpPost(
      `/vouchers/upload`,
      { Authorization: `Bearer ${body.faberToken}` },
      body.uploadObject
    )
  }

  /**
   * For ops to mass delete vouchers
   *
   */

  static deleteVouchers(
    faberToken: string
  ): AxiosPromise<DeleteVoucherResponse> {
    return FaberApi.httpDelete(`/vouchers`, {
      Authorization: `Bearer ${faberToken}`
    })
  }

  /**
   * For ops to assign voucher to a customer
   */
  static assignCustomerVoucher(body: {
    faberToken: string,
    userId: string,
    voucherSKU: string
  }): AxiosPromise {
    const {faberToken, userId, voucherSKU} = body;
    return FaberApi.httpPut(`/sim/ops/voucher/assign-voucher/${userId}/${voucherSKU}`, {
      Authorization: `Bearer ${faberToken}`
    });
  }
}

export default VouchersAPI

interface VouchersCSVData {
  expiryAt: string
  code: string
  currency: string
  value: number
  symbol: string
  partnerName: string
}
